{"en":"English","sv":"Svenska","da":"Dansk","no":"Norsk","fi":"Suomi"}